<a class="large-p" [style.color]="color" [routerLink]=" '../' + link" [id]="ctaId" [title]="text">
  <span [innerHTML]="text"></span>
  <div class="decorative-line"></div>
</a>
